export const faqLanguageOptions = [
  { value: "", label: "All languages" },
  { value: "ind", label: "Indonesia" },
  { value: "eng", label: "English" },
];

export const faqLanguageLabelMap = faqLanguageOptions
  .filter((option) => option.value)
  .reduce((result, option) => {
    result[option.value] = option.label;
    return result;
  }, {});
